import algoliasearch from 'algoliasearch/lite';

export const searchClient = algoliasearch(
  '4SH29IURF7',
  '5f1d863411cfe2e1a6cf6c90ff871e27',
);
